package com.snakesworld.game.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.snakesworld.game.engine.LeaderboardEntry
import com.snakesworld.game.network.MultiplayerRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class LeaderboardUiState(
    val isLoading: Boolean = true,
    val entries: List<LeaderboardEntry> = emptyList(),
    val errorMessage: String? = null,
)

class LeaderboardViewModel(
    private val repository: MultiplayerRepository,
) : ViewModel() {

    private val _uiState = MutableStateFlow(LeaderboardUiState())
    val uiState: StateFlow<LeaderboardUiState> = _uiState.asStateFlow()

    init {
        loadLeaderboard()
    }

    fun loadLeaderboard() {
        viewModelScope.launch {
            _uiState.value = _uiState.value.copy(isLoading = true, errorMessage = null)
            try {
                val list = repository.getLeaderboard()
                _uiState.value = LeaderboardUiState(
                    isLoading = false,
                    entries = list
                )
            } catch (e: Exception) {
                _uiState.value = LeaderboardUiState(
                    isLoading = false,
                    errorMessage = e.message
                )
            }
        }
    }
}
